
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTWEDGEPLAY_ACTION,
    ALL_ORTWEDGEPLAY,
    ADD_ORTWEDGEPLAY,
    FETCH_ORTWEDGEPLAY,
    EDIT_ORTWEDGEPLAY,
    DELETE_ORTWEDGEPLAY,
    FETCH_ORTWEDGECHART,
    FETCH_ORTWEDGESHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Wedge Play Test Actions
 */

    export const allORTWedgeTest = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTWEDGEPLAY_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonrwedge', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTWEDGEPLAY, payload: alldata });
            });
        }        

    }

    export const studentORTWedgeTest = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonrwedge', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTWEDGEPLAY, payload: alldata }); 
            });
        
        }
    }

    export const addORTWedgeTest = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='distance_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var shotadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonrwedge', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTWedgeTest(stdid, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTWedgeReport(stdid, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTWEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTWedgeTest = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrwedgedetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTWEDGEPLAY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTWedgeTest = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='distance_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var shotadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonrwedge', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTWedgeTest(stdid, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTWedgeReport(stdid, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTWEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTWedgeTest = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonrwedge', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTWedgeTest(id, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTWedgeReport(id, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTWEDGEPLAY});                    
                }                
                
            });
        
        }
    }

    export const fetchORTWedgeReport = (id, start, end, distance, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "distance":distance,
            "contact":contact,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangewedgereport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTWEDGECHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

    export const fetchORTWedgeShotChart = (id, start, end, distance, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "distance":distance,
            "contact":contact,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTWEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangewedgeshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTWEDGESHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

